export const SCENARIO_MAPS = {
 AQTUDTV2 : [
  {"AQT" : ["ACM"]},
  {"FTV" : ["FTV","CTS","FOS"]}
 ]
}
